$.fn.fileUploadHandler = function () {
  return this.each(function () {
    function handleFileChooserChange(e) {
      // Capture the uploaded files, convert it to a REAL array, and add it to the files tracker...
      files = Array.prototype.slice.call(e.target.files);

      // If it's multiple file-chooser
      if ($fileChooser.is("[multiple]")) {
        displayUploadList(e);
      } else {
        // Assume it's a single-file-chooser -- Do nothing...
      }

      // Update the filename field with the number of files uploaded
      filename = files.length
        ? getFilenamePlaceholder()
        : filenameFieldPlaceholder;
      $filenameField.val(filename);
      $filenameField.attr("placeholder", filename);
    }

    function getFilenamePlaceholder() {
      if ($fileChooser.is("[multiple]")) {
        return files.length + (files.length > 1 ? " files" : " file");
        // return files.length > 1
        //         ? files.length + ' files'
        //         : files.length + ' file';
      } else {
        // single-file upload

        // return the chosen file's name
        return $fileChooser.val().split("\\").pop();
      }
    }

    function displayUploadList(event) {
      var $list, $listItem;

      // Remove any old Upload list
      $fileUploadContainer.find(".upload-list").remove();

      // Create new upload list
      $list = $('<ul class="upload-list"></ul>');

      // Iterate over each uploaded file, to output a matching list-item
      var i = 0,
        len = files.length;
      for (i; i < len; i++) {
        $listItem = $(
          '<li data-files-index="' +
            i +
            '" class="upload-list-item">' +
            files[i].name +
            "</li>",
        );
        $list.append($listItem);
      }

      // Inject the newly-updated uploaded files listing
      $fileUploadContainer.append($list);
    }

    // INIT
    // =====================================

    var $fileUploadContainer = $(this);

    var $pseudoUploadButton = $fileUploadContainer.find(
      "span[role=button]:first",
    );
    var $fileChooser = $fileUploadContainer.find("input[type=file]:first");
    var $filenameField = $fileUploadContainer.find("input.form-control:first");

    // Cache original placeholder
    var filenameFieldPlaceholder = $filenameField.attr("placeholder");

    // Holder of uploaded files
    var files;

    // Filename placeholder after a successful upload
    var filename;

    // EVENTS BINDING
    // =====================================

    // Handle file upload
    $fileChooser.on("change", handleFileChooserChange);

    // trigger upload on space & enter
    // = standard button functionality
    $pseudoUploadButton.bind("keypress", function (e) {
      if (e.which === 32 || e.which === 13) {
        e.preventDefault();
        $fileChooser.click();
      }
    });

    /**
     * Refs:
     * - https://accessabilly.com/a-styled-accessible-file-upload/
     * - https://stackoverflow.com/questions/32002431/when-upload-multiple-file-file-name-show-in-text-box-with-a-delete-button
     */
  });
};
